import { Badge } from "reactstrap";
import { numberToWords } from "@persian-tools/persian-tools";

import { numberSeparate } from "../../utils";

export const ConvertCurrency = ({ price, per }) => {
  if (!price) return price;
  let displayPrice = price;
  if (per) displayPrice = Math.floor(price / per);

  return <span className="fw-bold">{numberSeparate(displayPrice)}</span>;
};

export const ConvertCurrencyToText = ({ price, isCurrency }) => {
  if (!price || price.length >= 17) return null;

  return (
    <>
      <span className="fw-bold">{numberToWords(price)}</span>
      {isCurrency && <Currency className="ml-1" />}
    </>
  );
};

const Currency = ({ className = "", isNormal }) => {
  const currency = "تومان";

  if (isNormal) return <>{currency}</>;
  return (
    <Badge color="info" className={`badge-dim ${className}`}>
      {currency}
    </Badge>
  );
};

export default Currency;
